import React, { useEffect } from "react";
import styles from "./Print.module.css";

import { useReactToPrint } from "react-to-print";
import Button from "../components/Button";
import { symbol } from "prop-types";
import ServerList from "../components/ServerList";
//import { ComponentToPrint } from "../ComponentToPrint";

function PrintEventSummary({ eventData, serverData }) {
  const componentRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const getTimeValue = (aDate) => {
    if (!aDate) {
      return;
    }
    let theDate = new Date(aDate.slice(0, -1));
    let hours = theDate.getHours();
    let minutes = theDate.getMinutes();

    if (hours != 0) {
      return `${hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours > 12 ? "pm" : "am"}`;
    }
  };

  // const apps = eventData.details.filter((el) => el.Category == "APP" && el.menuItemNotes != null);
  // const ents = eventData.details.filter((el) => el.Category == "ENT" && el.menuItemNotes != null);
  // const dess = eventData.details.filter((el) => el.Category == "DES" && el.menuItemNotes != null);
  // const bevs = eventData.details.filter((el) => el.Category == "BEV" || (el.Category == "BEV-NA" && el.menuItemNotes != null));

  const banquetTotal =
    Number(eventData.fbTotal) +
    Number(eventData.barTotal) +
    Number(eventData.serviceTotal) +
    Number(eventData.otherTotal) +
    Number(eventData.RoomCharge) +
    Number(eventData.addlGrat);

  useEffect(() => {
    reactToPrintFn();
  }, []);

  return (
    <>
      <div className="printOnly">
        <div ref={contentRef}>
          <div className={styles.printFrame}>
            <div className={`${styles.printSection1of1} ${styles.center} ${styles.pt1}`}>
              <span className={styles.titleBox}>EVENT SUMMARY</span>
            </div>
            <div className={styles.flexSectionColumn}>
              {/* Header Area */}
              <div className={styles.printSection1of2}>
                <h3>EVENT: {eventData.BanquetName}</h3>
              </div>
              <div className={`${styles.printSection1of2} ${styles.right}`}>
                <h3>EVENT DATE: {new Date(eventData.BanDate.replace("Z", "")).toDateString()}</h3>
              </div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={styles.printSection1of3}>
                <div className={styles.contactInfo}>
                  <h5>Contact Info</h5>
                  <p>{eventData.FirstName + " " + eventData.LastName}</p>
                </div>
                <div className={styles.eventInfo}></div>
                <div className={styles.serverInfo}></div>
              </div>
              <div className={styles.printSection1of3}>
                <div className={styles.contactInfo}>---</div>
              </div>
              <div className={`${styles.printSection1of3} ${styles.right}`}>
                <div className={styles.serverInfo}>---</div>
              </div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={`${styles.printSection1of1} ${styles.printContent}`}>
                <div className={styles.printSection1of3}>
                  Guest Count: <b>{eventData.BanAttendance}</b>
                </div>
                <div className={`${styles.printSection1of3} ${styles.center}`}>
                  Banquet Room: <b>{eventData.RoomName}</b>
                </div>
                <div className={`${styles.printSection1of3} ${styles.right}`}>
                  Service Type: <b>{eventData.ServiceTypeName}</b>
                </div>
              </div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={`${styles.printSection1of1}`}>
                <h5 className={styles.mb1}>Item Detail</h5>
                <table className={`${styles.table} ${styles.table_3}`}>
                  <thead>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Price</th>
                  </thead>
                  <tbody>
                    {Array.isArray(eventData.details) &&
                      eventData.details.map((bd, index) => {
                        if (bd.Category != "ONF")
                          if (bd.isParent) {
                            return (
                              <tr>
                                <td>{bd.item}</td>
                                <td>{bd.qty}</td>
                                <td>${Number(bd.pricePerTotal).toFixed(2)}</td>
                              </tr>
                            );
                          }
                      })}
                    <tr>
                      <td>Room Charge</td>
                      <td></td>
                      <td>{Number(eventData.RoomCharge).toFixed(2)}</td>
                    </tr>
                    <tr className={styles.totalRow}>
                      <td>Event Total</td>
                      <td></td>
                      <td>{Number(banquetTotal).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Deposit</td>
                      <td></td>
                      <td>-{Number(eventData.Deposit).toFixed(2)}</td>
                    </tr>
                    <tr className={`${styles.totalRow} ${styles.totalRowBoxed}`}>
                      <td>Amount Due</td>
                      <td></td>
                      <td>{Number(banquetTotal - eventData.Deposit).toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />

              <div className={`${styles.printSection1of1}`}>
                <h5 className={styles.mb1}>Employee Detail</h5>
                <table className={styles.employeeTable}>
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Role</th>
                      <th>Grat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ServerList servData={serverData} />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Button type="secondary" onClick={() => reactToPrintFn()}>
        Print Event Detail FOH
      </Button> */}
    </>
  );
}

export default PrintEventSummary;
